import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ABTestDefinition } from '../interfaces/models';
import { ABTestApiServiceInterface } from '../interfaces/external';
import { AB_TEST_HTTP_SERVICE, AB_TEST_BASE_URL } from '../tokens/external.tokens';

@Injectable({
  providedIn: 'root',
})
export class ABTestApiService implements ABTestApiServiceInterface {
  private httpService = inject(AB_TEST_HTTP_SERVICE);
  private baseUrl = inject(AB_TEST_BASE_URL);

  /**
   * Get all active AB test configurations from the backend
   * @returns Observable of active test definitions
   */
  getActiveTests(): Observable<ABTestDefinition[]> {
    //Mock for now, until nestJS part is ready
    return of([]);

    //const url = `${this.baseUrl}/ux-testing/ab-test`;
    //return this.httpService.get<ABTestDefinition[]>(url);
  }
}
